import CryptoMain from "@/components/dashboard/crypto/CryptoMain";

export default function Crypto() {
  return <CryptoMain />;
}
